import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */



@Component({
  selector: 'page-denied-reservation',
  templateUrl: 'denied-reservation.html',
})
export class DeniedReservationPage {

  title: any;
  denied_reason: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public translate: TranslateService) {
    this.title = this.navParams.get('title');
  }

  close() {
    this.viewCtrl.dismiss(false);
  }

  save() {
    this.viewCtrl.dismiss(this.denied_reason);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/denied-reservation/denied-reservation.ts